import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import FieldSet from 'flarum/common/components/FieldSet';
import ItemList from 'flarum/common/utils/ItemList';
import Switch from 'flarum/common/components/Switch';
import Stream from 'flarum/common/utils/Stream';
export default function () {
  extend('flarum/forum/components/SettingsPage', 'oninit', function () {
    var _this$user, _this$user2;
    this.showSynopsisExcerpts = Stream((_this$user = this.user) == null || (_this$user = _this$user.preferences()) == null ? void 0 : _this$user.showSynopsisExcerpts);
    this.showSynopsisExcerptsOnMobile = Stream((_this$user2 = this.user) == null || (_this$user2 = _this$user2.preferences()) == null ? void 0 : _this$user2.showSynopsisExcerptsOnMobile);
  });
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    items.add('synopsis', FieldSet.component({
      label: app.translator.trans('fof-synopsis.forum.user.settings.summaries-heading'),
      className: 'Settings-Synopsis'
    }, this.summariesItems().toArray()));
  });
  override('flarum/forum/components/SettingsPage', 'summariesItems', function () {
    const items = new ItemList();
    if (!this.user) return items;
    const prefs = this.user.preferences();
    items.add('synopsis-excerpts', Switch.component({
      state: prefs == null ? void 0 : prefs.showSynopsisExcerpts,
      onchange: value => {
        var _this$user3;
        this.showSynopsisExcerptsLoading = true;
        (_this$user3 = this.user) == null || _this$user3.savePreferences({
          showSynopsisExcerpts: value
        }).then(() => {
          this.showSynopsisExcerptsLoading = false;
          m.redraw();
        });
      },
      loading: this.showSynopsisExcerptsLoading
    }, app.translator.trans('fof-synopsis.forum.user.settings.show-summaries')));
    if (prefs != null && prefs.showSynopsisExcerpts) {
      items.add('synopsis-excerpts-mobile', Switch.component({
        state: prefs == null ? void 0 : prefs.showSynopsisExcerptsOnMobile,
        disabled: !(prefs != null && prefs.showSynopsisExcerpts),
        onchange: value => {
          var _this$user4;
          this.showSynopsisExcerptsOnMobileLoading = true;
          (_this$user4 = this.user) == null || _this$user4.savePreferences({
            showSynopsisExcerptsOnMobile: value
          }).then(() => {
            this.showSynopsisExcerptsOnMobileLoading = false;
            window.location.reload();
          });
        },
        loading: this.showSynopsisExcerptsOnMobileLoading
      }, app.translator.trans('fof-synopsis.forum.user.settings.show-summaries-mobile')));
    }
    return items;
  });
}